module.exports = __webpack_public_path__ + "static/media/trainer.3bc4f677.png";